import { State } from "@/@types/State";
import { StateResponse } from "../../contactUsForm/models/StatesRespones";

export function mapStates(response: StateResponse[]): State[] {

    //console.log(response);

    return response.map(state => ({
        id : state.id,
        key: state.key,
        name: state.name,
        abbrev: state.abbrev,
        active: state.active
    }));
}